import { createTheme } from '@mui/material/styles';

const baseTheme = createTheme();

const theme = {
    ...baseTheme,
    palette: {
        ...baseTheme.palette,
     primary: {
      ...baseTheme.palette.primary,
        main: '#0072e4',
        dark: '#1D4ED8',
        contrastText: '#fff',
     },
     secondary: {
        ...baseTheme.palette.secondary,
        main: '#838383',
        contrastText: '#000000', 
     },
     error: {
         ...baseTheme.palette.error,
         main: '#fb544e',
         contrastText: '#000000',
     },
     warning: {
         ...baseTheme.palette.warning,
         main: '#ffbb00',
         dark: '#D97706',
         contrastText: '#000000',
     },
     border :{
        ...baseTheme.palette.border,
        main: '#EFF0F6',
     },
     background: {
        ...baseTheme.palette.background,
        main: '#FFFFFF',
        surface: '#F9FAFB',
     },
     text: {
      ...baseTheme.palette.text,
      //primary: '#000000',
      secondary: '#838383', 
      disabled: '#C0C0C0',
      tertiary: '#4D4D4D',
    },
     green: {
    main: '#23DD9A',
    contrastText: '#fff',
  },
    },
    colorSchemes: {
      ...baseTheme.colorSchemes,
      dark: true,
    },
    typography: {
        ...baseTheme.typography,
        fontFamily: 'Inter, Arial, sans-serif', 
        fontSize: 14,
        serialC :{
            fontWeight : 400,
            letterSpacing: '-0.2px',
            fontFamily : 'SerialC, Arial, sans-serif',
            fontSize: 'clamp(5px, 1vw + 0.8px, 12px)',
        },
        h1 :{
            ...baseTheme.typography.h1,
            color: 'var(--Base-Shade-100, #000)',
            /* Headline */
            fontFamily: 'Inter, Arial, sans-serif',
            fontSize: 'clamp(2em, 1vw + 0.5em, 4em)',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: 'normal',
        },
        h2 :{
            ...baseTheme.typography.h2,
            color: 'var(--Base-Shade-100, #000)',
            /* Headline */
            fontFamily: 'Inter, Arial, sans-serif',
            fontSize: 'clamp(1.5em, 0.7vw + 0.3em, 3em)',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: 'normal',
        },
        h3 :{
            ...baseTheme.typography.h3,
            /* Headline */
            fontFamily: 'Inter, Arial, sans-serif',
            fontSize: 18,
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: 'normal',
        },
        h5 :{
            ...baseTheme.typography.h4,
            /* Headline */
            fontFamily: 'Inter, Arial, sans-serif',
            fontSize: 13,
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: 'normal',
        },
        body2 : {
            ...baseTheme.typography.body2,
            fontFamily: 'Inter, Arial, sans-serif',
            fontWeight: 400,    
        },
        body3: {
          ...baseTheme.typography.body1,
          fontFamily: 'Inter, Arial, sans-serif',
          fontSize: 'clamp(0.5em, 1vw + 0.01em, 0.7em)',
          fontWeight: 400,
        },
        subtitle1:{
            ...baseTheme.typography.subtitle1,
            fontFamily: 'Inter, Arial, sans-serif',
            fontWeight: 500,
        },
        secondary: {
            ...baseTheme.typography.secondary,
            color:'#838383', // Utilise la couleur définie dans palette.secondary
            fontSize: 'clamp(0.5em, 1vw + 0.05em, 0.8em)',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
            fontFamily: 'Inter, Arial, sans-serif', 
        },
        subtitle2: {
            ...baseTheme.typography.subtitle2,
            color: 'var(--Base-Shade-70, rgba(0, 0, 0, 0.70))',
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: 'Inter, Arial, sans-serif',
            fontSize: 'clamp(0.5em, 1vw + 0.05em, 0.8em)',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
            letterSpacing: '-0.3px',
        },
    },
    container :{
        ...baseTheme.container,
        borderRight: '1px solid #e0e0e0',
        backgroundColor: '#fff',
        borderRadius: '20px', 
        boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.10)',
    },
    menu : {
        ...baseTheme.menu,
        backgroundColor: '#fff',
        borderRadius: '0px 20px  20px 0px', 
        boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.10)',
    },
    divider :{
        ...baseTheme.divider,
        borderColor: '#E5E5E5',
        borderWidth: 1,
        opacity:1,
    },
    center : {
        ...baseTheme.center,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    shape : {
        ...baseTheme.shape,
        borderRadius: 15,
    },
   shadows: {
        ...baseTheme.shadows,
        0: 'none',
        1: '0px 1px 2px rgba(0, 0, 0, 0.05)',
        2: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        3: '0px 4px 8px rgba(0, 0, 0, 0.15)',
        // Add more custom shadows as needed
    },
    components: {
    MuiTab: {
      styleOverrides: {
        root: {
          fontFamily: 'Inter, Arial, sans-serif',
          fontWeight: 700,
          textTransform: 'uppercase',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'Inter, Arial, sans-serif',
          fontWeight: 500,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        subtitle1: ({ theme }) => ({
          [theme.breakpoints.down('md')]: {
            fontSize: '0.8rem',
          },
          [theme.breakpoints.down('sm')]: {
            fontSize: '0.7rem',
          },
          [theme.breakpoints.down('xs')]: {
            fontSize: '0.7rem',
          },
        }),
         body2: ({ theme }) => ({
          [theme.breakpoints.down('md')]: {
            fontSize: '0.7rem',
          },
          [theme.breakpoints.down('sm')]: {
            fontSize: '0.6rem',
          },
          [theme.breakpoints.down('xs')]: {
            fontSize: '0.6rem',
          },
        }),
      },
      variants : [
        {
          props: { variant: 'body3'},
          style:{
            ...baseTheme.typography.body1,
            fontFamily: 'Inter, Arial, sans-serif',
            fontSize: 'clamp(0.5em, 1vw + 0.01em, 0.7em)', 
            fontWeight: 400,
          }
        }
      ]
    },
  },
   };
 
export default theme;